import React from "react";
import styles from "./Styles";
import { Card, CardContent, Typography, List } from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import { Link } from "react-admin";
import { canAccess } from "../../rbac";

const REPORT_ITEMS = [
  { to: "/reportsYearSales", text: "Reports Sales", permission: "reportsYearSales" },
  { to: "/reportsEmails", text: "Reports Emails", permission: "reportsEmails" },
  { to: "/reportsTours", text: "Reports Tours", permission: "reportsTours" },
  { to: "/reportsRentals", text: "Reports Rentals", permission: "reportsRentals" },
  { to: "/reportsSales", text: "Reports Sales By Range", permission: "reportsSales" },
  { to: "/reportsRentalsByRange", text: "Reports Rentals By Range", permission: "reportsRentalsByRange" },
  { to: "/reportToursCharges", text: "Reports Tours Charges", permission: "reportToursCharges" },
  { to: "/reportFutureIncome", text: "Reports Future Income", permission: "reportFutureIncome" },
  { to: "/clientsMerge", text: "Merge Accounts", permission: "clientsMerge" },
];

export class ReportsOptions extends React.Component {
  render() {
    return (
      <Card style={styles.cardStyle}>
        <Typography
          gutterBottom
          variant="h6"
          component="h2"
          style={styles.cardHeaderStyle}
        >
          Reports
        </Typography>
        <CardContent style={styles.CardContent}>
          <List>
            {REPORT_ITEMS.map(
              ({ to, text, permission }) =>
                canAccess(permission) && (
                  <ListItem key={to}>
                    <Link to={to}>{text}</Link>
                  </ListItem>
                )
            )}
          </List>
        </CardContent>
      </Card>
    );
  }
}

export default ReportsOptions;



// WEBPACK FOOTER //
// ./src/components/dashboard/ReportsOptions.js